import React from "react";
import { downloadExcel } from "react-export-table-to-excel";
import { Button } from ".";
import { buttonClasses } from "./theme";

const GenericDownloadTable = ({ headers = [], rows = [], fileName = "export" }) => {

  const handleDownload = () => {
    if (!headers.length || !rows.length) {
      console.error("No data to export");
      return;
    }

    downloadExcel({
      fileName,
      sheet: fileName,
      tablePayload: {
        header: headers,
        body: rows
      }
    });
  };

  return (
    <div>
      <Button
		text={"Download Excel"}
		style={{
            ...buttonClasses.lynkitOrangeFill,
		}}
		onClick={handleDownload}
	/>
    </div>
  );
};

export default GenericDownloadTable;
